<template>
  <div class="bodys" v-if="body_show">
    <div class="top">
      <h1>
        <img src="../../assets/logo.png" @click="statistical_l">
      </h1>
      <swiper v-if="is_swiper" :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in banner" :key="index">
          <router-link :to="links[index]">
            <img :src="item.imgurl">
          </router-link>
        </swiper-slide>
      </swiper>
    </div>
    <div class="choose clearfix">
      <ul>
        <li>
          <div @click="statistics({type:'icon1'})">
            <img src="https://themes-cdn.xjy.cn/statics/career/images/choose1.png">
            <p>价值提升</p>
          </div>
        </li>
        <!-- <li>
          <div @click="statistics({type:'icon2'})">
            <img src="https://themes-cdn.xjy.cn/statics/career/images/choose2.png">
            <p>1v1辅导</p>
          </div>
        </li> -->
        <li>
          <div @click="statistics({type:'icon3'})">
            <img src="https://themes-cdn.xjy.cn/statics/career/images/choose3.png">
            <p>来测一下</p>
          </div>
        </li>
      </ul>
    </div>

    <div @click="statistical_link(1)" v-if="promotion.imgurl">
      <img :src="promotion.imgurl" class="tg_img">
    </div>
    <div class="index_list" id="kc">
      <h2>
        {{course.name}}
        <span v-if="course.begintime>0">
          距离开课还有
          <span>{{course.begintime}}</span>天
        </span>
      </h2>
      <a @click="statistical_link(0)">
        <img :src="course.imgurl">
      </a>
    </div>
    <!-- <div class="index_list" id="kc2">
      <h2>
        {{coach.name}}
        <span v-if="coach.coachnum>0">本周剩余名额
          <span>{{coach.coachnum}}</span>位
        </span>
      </h2>
      <a @click="statistical_link1">
        <img :src="coach.imgurl">
      </a>
    </div> -->
    <div class="index_list last" id="kc3">
      <h2>来测一下</h2>
      <a @click="statistical_link2">
        <h3>参与人数: {{xplan.num}}人</h3>
        <img src="https://themes-cdn.xjy.cn/statics/career/images/cepsv.png">
      </a>
    </div>
    <!-- 公用底部 -->
    <public-footer :childMsg="0" :routArg="routArg"></public-footer>
    <!-- 公用音频底部 -->
    <public-foot-audio :footerShow="footer_show"></public-foot-audio>
  </div>
</template>
<script>
import {
  index
} from "@/api/index";
import {
  statistics
} from "@/api/public";
import {
  queryString,
  isMain
} from "@/utils/tools";
import "swiper/dist/css/swiper.css";

import {
  swiper,
  swiperSlide
} from "vue-awesome-swiper";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        swiperOption: {
          autoplay: {
            delay: 3000
          },
          loop: true,
          spaceBetween: 10,
          slidesPerView: 1.1,
          loopedSlides: 5,
          centeredSlides: true,
          observer: false,
          initialSlide: 1,
          speed: 250
        },
        is_swiper: false,
        banner: [],
        distinct_id: "",
        promotion: "",
        course: "",
        coach: "",
        xplan: "",
        play_true: false,
        bid: "",
        cid: "",
        body_show: false,
        footer_show: true,
        link: [],
        querys: {},
        routArg: {}
      };
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      },
      is_main() {
        return isMain()
      }
    },
    components: {
      swiper,
      swiperSlide
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        index().then(data => {
          this.body_show = true;
          this.$toast.clear();
          this.banner = data.banner;
          this.is_swiper = true;
          this.distinct_id = data.openid;
          this.promotion = data.promotion;
          this.course = data.course;
          this.coach = data.coach;
          this.xplan = data.xplan;
          let querys = this.$route.query;
          querys.bid = queryString(this.promotion.link, "bid");
          this.links = {
            0: {
              path: "/course_details",
              query: querys
            },
            1: "/mentor_details"
          };
          if (querys.source) {
            this.routArg['source'] = querys.source;
          }
          if (querys.pdk) {
            this.routArg['pdk'] = querys.pdk;
          }
          if (querys.aspx) {
            this.routArg['aspx'] = querys.aspx;
          }
        });
      },
      statistical_l() {
        statistics({
          type: "lefticon"
        }).then(data => {
          // this.$router.push("/index");
        });
      },
      statistical_link(num) {
        statistics({
          type: num == 1 ? "extension" : "coursecard"
        });
        this.bid = queryString(this.promotion.link, "bid");
        let querys = this.$route.query;
        querys.bid = queryString(this.promotion.link, "bid");
        this.$router.push({
          path: "/course_details",
          query: querys
        });
      },
      statistical_link1() {
        statistics({
          type: "coachcard"
        });
        this.$router.push("/mentor_details");
        // if(this.is_main){
        //   window.location.href= "https://api.xjy.cn/tools/career/totoring/mentor_details.html";
        // }else{
        //   window.location.href= "https://api.xjy.cn/develops/career/totoring/mentor_details.html";
        // }
      },
      statistical_link2() {
        statistics({
          type: "xplancard"
        });
        this.cid = queryString(this.xplan.link, "cid");
        this.$router.push("/measurement_details?cid=" + this.cid);
      },
      onScroll() {
        window.onscroll = (ev) => {
          let t = document.documentElement.scrollTop || document.body.scrollTop;
          let w = 100;
          if (t > w) {
            this.footer_show = false;
          } else {
            this.footer_show = true;
          }
        }
      }
    },
    created() {
      this.pullData();
      shareCon("index", this);
    },
    mounted() {
      this.onScroll()
    }
};
</script>

<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  text-align: center;
  padding-bottom: changeRem(2) + px
}

.top {
  width: 100%;
  height: 346px;
  background: linear-gradient( -90deg, rgba(235, 80, 50, 1) 0%, rgba(245, 127, 23, 1) 100%);
  margin-bottom: 40px;
  h1 {
    line-height: changeRem(1.78) + px;
    padding-left: changeRem(0.6) + px;
    font-size: changeRem(0.68) + px;
    color: rgba(254, 254, 254, 1);
    text-align: left;
    line-height: 1;
    padding: changeRem(0.4) + px changeRem(0.6) + px;
    img {
      width: 240px;
    }
  }
}

.swiper-container {
  width: 100%;
  height: 6rem;
  img {
    width: 100%;
  }
}

.choose {
  margin: 0 changeRem(0.6) + px;
  padding: changeRem(0.6) + px 0;
  border-bottom: 1px solid #cccccc;
  ul{
    display: flex;
    justify-content: space-around;
  }
  ul li {
    text-align: center;
    width: 33.33%;
    img {
      width: changeRem(1.76) + px;
      height: changeRem(1.76) + px;
    }
    p {
      font-size: changeRem(0.52) + px;
      color: rgba(0, 0, 0, 1);
      margin-top: changeRem(0.2) + px;
      line-height: changeRem(0.48) + px;
    }
  }
}

.tg_img {
  width: changeRem(13.8) + px;
  margin: 0 auto;
  margin-top: changeRem(0.6) + px;
}

.index_list {
  margin: 0 changeRem(0.6) + px;
  margin-top: changeRem(1.2) + px;
  h2 {
    color: #333333;
    font-size: changeRem(0.68) + px;
    text-align: left;
  }
  a {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    margin-top: changeRem(0.4) + px;
    h3 {
      position: absolute;
      top: changeRem(1.44) + px;
      left: changeRem(1) + px;
      color: #999;
      font-size: changeRem(0.44) + px;
    }
  }
  img {
    width: 100%;
  }
}

.last h2 {
  padding-top: changeRem(0.8) + px;
  border-top: 1px solid #ccc;
}
</style>
